import styled from 'styled-components';
import { FiraSansBold, FontWeight } from '../Text';
import Colors from 'constants/Colors';

export const Dialog = styled.div`
  position: fixed; 
  z-index: 5; 
  padding-top: 30vh;
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgba(255,255,255,0.4);
  display: ${({ canShow }) => canShow ? 'block' : 'none'};
`;

export const DialogBody = styled.div`
  background-color: #fefefe;
  margin: auto;
  padding: 25px;
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  width: 700px;
  height: auto;
  min-height: 100px;
  border-radius: 4px;
`;

export const DialogText = styled.p`
  color: ${Colors.GRAY[6]};
  font-weight: ${FiraSansBold};
  font-family: 'Fira Sans', sans-serif;
  font-size: 14px;
  text-transform: uppercase;
`;

export const ContentTextArea = styled.div`
  width: 100%;  
  margin-bottom: 8px;
  margin-top: 8px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight:${FiraSansBold};
  font-family:'Fira Sans', sans-serif;
  font-size: 14px;
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TextArea = styled.textarea`
width:100%;
height: 120px;
padding:15px;
border:2px solid ${Colors.GRAY[3]};
border-radius:8px;
resize:none;
font-family: Courier, monospace;
font-weight: ${FontWeight.SemiBold};
color: ${Colors.GRAY[6]};
font-size:14px;
`;